import { useCallback, useRef, useState } from "react";

/**
 * Runs an async function at most once at a time.
 * Ignores additional calls while a run is in progress.
 */
export const useGuardedAsync = () => {
  const inFlightRef = useRef(false);
  const [loading, setLoading] = useState(false);

  const run = useCallback(async (asyncFn) => {
    if (inFlightRef.current) return false;

    inFlightRef.current = true;
    setLoading(true);
    try {
      await asyncFn();
      return true;
    } finally {
      inFlightRef.current = false;
      setLoading(false);
    }
  }, []);

  return { loading, run };
};
